import React from 'react';
// import { CircleLoader } from 'react-spinners'; // Import CircleLoader
// Assuming you've installed react-spinners
import './Preloader.css'

const Preloader = () => {


    return (
        <div className="preloader">
            <h1 className='loader'> </h1>
        </div>
    );
};

export default Preloader;
